import styled from '@emotion/styled';
import {
    rem
} from '@triumph/design-system';

export const ButtonFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 30px 0px;
`;

export const BillingReminderTableWrapper = styled.div`
    tfoot {
        tr:nth-of-type(1) td {
            border-bottom: none;
        }

        tr {
            background-color: unset;
            td {
                line-height: ${rem(24)};
                padding-top: ${rem(20)};
                padding-bottom: ${rem(20)};
            }
        }
    }
`;

export const InvoiceDueDateColumnWrapper = styled.div`
    display: flex;
    align-items: center;
    color: #b82525;
`;

export const ColumnColorWrapper = styled.div<{
    useThemeColor?: boolean;
}>`
    input {
        background-color: ${({ theme, useThemeColor }) =>
        useThemeColor ? theme.colors.semantic.dangerSecondaryHover: null};
    }
    svg path {
        fill: ${({ theme, useThemeColor }) =>
        useThemeColor ? theme.colors.primary.actionDefault: null};
    }
`;